import {
  Container,
  Grid,
  Box,
  makeStyles,
  useTheme,
  Slide,
  Fade,
  Grow,
  Typography,
  Avatar,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: 'linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9)), url("/static/our_team.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  section: {
    padding: "40px 0",
    background: "#fafafa",
  },
  sectionWhite: {
    padding: "40px 0",
    background: "#ffffff",
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  teamCard: {
    background: "#ffffff",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease",
    height: "100%",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(107, 27, 107, 0.1)",
    },
  },
  teamImageContainer: {
    position: "relative",
    width: "100%",
    height: 180,
    background: "linear-gradient(135deg, #f8f4f8 0%, #f0e8f0 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  teamImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    padding: 12,
  },
  teamContent: {
    padding: "16px",
    textAlign: "center",
  },
  teamName: {
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#4c004c",
    marginBottom: 2,
  },
  teamDesignation: {
    fontSize: "0.75rem",
    color: "#6b1b6b",
    fontWeight: 500,
    marginBottom: 8,
  },
  teamDescription: {
    fontSize: "0.78rem",
    color: "#666666",
    lineHeight: 1.5,
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    marginTop: 32,
    textAlign: "center",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
}));
  
  export const OurTeam = () => {
    const theme = useTheme();
  
    const classes = useStyles();
    const [team1, setTeam1] = useState([]);
    const [team2, setTeam2] = useState([]);
    const [metaTitle, setMetaTitle] = useState("");
    const [metaDesc, setMetaDesc] = useState("");
    const [metaKeywords, setMetaKeywords] = useState("");
    const [isloading, setIsloading] = useState(true);
  
    const handleClick = () => {
      const anchor = document.querySelector("#back-to-top-anchor");
  
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };
  
    useEffect(() => {
      getMetaData();
    }, []);
  
    const getMetaData = async () => {
      const formData = new FormData();
      formData.append("page", 8);
      await Axios.post("/api/getmetadata", formData, {
        headers: { headKey: headKey },
      }).then((res) => {
        if (res.data.status) {
          setMetaTitle(res.data.data.meta_title);
          setMetaKeywords(res.data.data.meta_keywords);
          setMetaDesc(res.data.data.meta_desc);
          
          
        }
      });
      await  Axios.post("/api/get_all_team", {
        headers: { headKey: headKey },
      }).then((res) => {
        
        if (res.data.status) {
          setTeam1(res.data.team1);
          setTeam2(res.data.team2);
          setIsloading(false);
          handleClick();
          // console.log(res.data.status);
          // setData(ReactHtmlParser(res.data.data.description));
        }
      });
    };
  
      
    return (
      <div>
        <Helmet>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDesc} />
          <meta name="keywords" content={metaKeywords}></meta>
        </Helmet>
        {/* Hero Section */}
        <Box className={classes.heroSection}>
          <Fade in={true} timeout={1000}>
            <Box className={classes.heroContent}>
              <Typography className={classes.heroTitle}>
                Our Team
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                The Brains Behind Our Breakthroughs
              </Typography>
            </Box>
          </Fade>
        </Box>

        {isloading ? (
          <Loading />
        ) : (
          <>
          {/* Leadership Team Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Leadership Team
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Get to know our leaders, their expertise, and the vision that guides us
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={4}>
                {team1.map((team, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Grow in={true} timeout={800 + index * 150}>
                      <Box className={classes.teamCard}>
                        <Box className={classes.teamImageContainer}>
                          <img
                            src={"/static/team/" + team.image}
                            alt={team.name}
                            className={classes.teamImage}
                          />
                        </Box>
                        <Box className={classes.teamContent}>
                          <Typography className={classes.teamName}>
                            {team.name}
                          </Typography>
                          <Typography className={classes.teamDesignation}>
                            {team.designation}
                          </Typography>
                          <Typography className={classes.teamDescription}>
                            {team.description}
                          </Typography>
                        </Box>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          {/* Core Developers Section */}
          <Box className={classes.sectionWhite}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Core Developers
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Discover the talented developers behind our cutting-edge solutions
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={4}>
                {team2.map((team, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Grow in={true} timeout={800 + index * 150}>
                      <Box className={classes.teamCard}>
                        <Box className={classes.teamImageContainer}>
                          <img
                            src={"/static/team/" + team.image}
                            alt={team.name}
                            className={classes.teamImage}
                          />
                        </Box>
                        <Box className={classes.teamContent}>
                          <Typography className={classes.teamName}>
                            {team.name}
                          </Typography>
                          <Typography className={classes.teamDesignation}>
                            {team.designation}
                          </Typography>
                          <Typography className={classes.teamDescription}>
                            {team.description}
                          </Typography>
                        </Box>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>

              {/* Quote Section */}
              <Fade in={true} timeout={1400}>
                <Box className={classes.quoteSection}>
                  <Typography className={classes.quoteText}>
                    "At Arawinz, our ethos is rooted in the seamless fusion of creativity and commitment, driving us to provide outstanding results. Our path is defined by an unwavering dedication to surpassing expectations and an earnest endeavor to grasp and cater to our clients' unique requirements. As a collective, we transcend mere collaboration – we are visionaries shaping tomorrow, piecing together a more intelligent and interconnected reality."
                  </Typography>
                  <Typography className={classes.quoteAuthor}>
                    — Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Fade>
            </Container>
          </Box>
        </>
        )}
     
      </div>
    );
  };
  

